import { faAnglesRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Card } from 'antd'
import BackButton from '../misc/BackButton'
import React from 'react'
import TeamTile from './TeamTile'

const THIRD_PLACE_TEAM_COUNT = 8

export default function AdvancingThirdPlaceForm({
  advancingThirdPlaceTeams,
  groupRankings,
  isAdmin,
  rankings,
  setAdvancingThirdPlaceTeams,
  setStep,
}) {
  const thirdPlaceTeams = Object.entries(groupRankings)
    .map(([groupName, placements]) => {
      const teamId = placements[2]
      if (!teamId) return null

      const ranking = rankings[String(teamId)]
      return {
        groupName,
        value: teamId,
        name: ranking?.name ?? String(teamId),
        rank: ranking?.rank ?? null,
        flag: ranking?.flag ?? '/flags/Mystery.png'
      }
    })
    .filter(Boolean)
    .sort((a, b) => a.name.localeCompare(b.name))
  const autoRankThirdPlaceTeams = () => {
    const topEight = [...thirdPlaceTeams]
      .sort((teamA, teamB) => {
        const rankA = typeof teamA.rank === 'number' ? teamA.rank : Number.MAX_SAFE_INTEGER
        const rankB = typeof teamB.rank === 'number' ? teamB.rank : Number.MAX_SAFE_INTEGER
        if (rankA !== rankB) return rankA - rankB
        return teamA.name.localeCompare(teamB.name)
      })
      .slice(0, THIRD_PLACE_TEAM_COUNT)
      .map(team => team.value)

    setAdvancingThirdPlaceTeams(topEight)
  }

  const handleSelection = (teamId) => {
    const teamKey = String(teamId)
    if (advancingThirdPlaceTeams.some(value => String(value) === teamKey)) {
      setAdvancingThirdPlaceTeams(current => current.filter(value => String(value) !== teamKey))
      return
    }

    if (advancingThirdPlaceTeams.length >= THIRD_PLACE_TEAM_COUNT) {
      return
    }

    setAdvancingThirdPlaceTeams(current => [...current, teamId])
  }

  return (
    <div className="bracket-group-form">
      <BackButton onClick={() => setStep(1)} text="Group Stage"/>
      <div className="groups-header">
        <h1 className="wc-font">Advancing Third Place Teams</h1>
        <p className="wc-font header-description">Select eight of the teams listed below before moving on.</p>
        <p className="wc-font header-description">{`${advancingThirdPlaceTeams.length} of ${THIRD_PLACE_TEAM_COUNT} selected`}</p>
        {isAdmin && <Button onClick={autoRankThirdPlaceTeams}>Auto-rank countries</Button>}
      </div>
      <div className="groups-container">
        <Card className="group-card third-place-card">
          {thirdPlaceTeams.map(team => (
            <TeamTile
              key={`${team.groupName}-${team.value}`}
              team={team}
              selected={advancingThirdPlaceTeams.some(value => String(value) === String(team.value))}
              onClick={() => handleSelection(team.value)}
            />
          ))}
        </Card>
      </div>
      <div className="groups-footer">
        <Button disabled={advancingThirdPlaceTeams.length !== THIRD_PLACE_TEAM_COUNT} type="primary" onClick={() => {
          setStep(3)
          window.scrollTo(0, 0)
        }}>
          Continue to Knockout Stage&nbsp;
          <FontAwesomeIcon icon={faAnglesRight} />
        </Button>
      </div>
    </div>
  )
}
